import { Stage } from 'application/stage'
import { createStore, sample } from 'effector'
import { useStore } from 'effector-react'
import { CarsList } from 'features/cars-list/components'
import { CreditFilterForm } from 'features/credit-filter-form/components'
import { Filter } from 'features/filter/components'
import { RoutingPanel } from 'features/routing-panel/components'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { AVNStageProps } from 'stages/AVN/types'
import styled, { useTheme } from 'styled-components'
import { Cell, Container, Row } from 'ui/grid'

import { fetchCarsOnListFx, setSettingsRelatedFilter } from '../../features/cars-list/model'
import { fetchCitiesFx } from '../../features/city-select/model'
import { fetchDeclarationFx } from '../../features/filter/model'
import { getProjectName } from '../../lib/get-project-name'
import { StageError } from '../../ui/stage-error'
import GlobalStyles from './style/style'

const AVNContext = createContext<AVNStageProps>({} as AVNStageProps)

export const useAVNConfig = () => useContext(AVNContext)

const AVNProvider = AVNContext.Provider

const $failed = sample({
  clock: [fetchDeclarationFx.failData, fetchCitiesFx.failData, fetchCarsOnListFx.failData],
  fn: () => true,
  target: createStore(false)
})

export const AVN: Stage<AVNStageProps> = (props) => {
  const failed = useStore($failed)

  const theme = useTheme()
  const isCompactView = ['phone', 'phablet'].includes(theme.activeBreakpoint)
  const [creditFilterFormOpen, setCreditFilterFormOpen] = useState(false)

  useEffect(() => {
    setSettingsRelatedFilter({ isRelatedFilter: props.isRelatedFilter, filterOptions: props.filterOptions.data })
  }, [])

  if (failed)
    return (
      <Container>
        <StageError>{props.i18n.loadingError}</StageError>
      </Container>
    )

  return (
    <AVNProvider value={props}>
      {props.routingPanel?.showPanel &&
        (props.routingPanel.cards.length > 0 || props.routingPanel?.useBackendFilter) &&
        ((isCompactView && props.isShowRoutingPanelOnMobile) ||
          !isCompactView ||
          getProjectName() === 'generic_v2') && (
          <RoutingWrapper style={{ backgroundColor: props.routingPanel.backgroundColor || '#FFF' }}>
            <Container>
              <Row>
                <Cell>
                  <RoutingPanel {...props.routingPanel} hasCitySelection={!!props.citySelect} />
                </Cell>
              </Row>
            </Container>
          </RoutingWrapper>
        )}
      {getProjectName() === 'haval' && <GlobalStyles />}
      <ListWrapper
        style={{ background: props.forceBackgroundColor ? props.forceBackgroundColor : props.listBackground }}
      >
        <Container className="cars-list">
          <CreditFilterForm onClose={() => setCreditFilterFormOpen(false)} show={creditFilterFormOpen} />
          <Row>
            <Cell size={12} tablet={4} projectors={3} className="filter-cell">
              <Filter />
            </Cell>
            <Cell size={12} tablet={8} projectors={9}>
              <CarsList />
            </Cell>
          </Row>
        </Container>
      </ListWrapper>
    </AVNProvider>
  )
}

export default AVN

const RoutingWrapper = styled.div`
  padding-bottom: 4rem;
`

const ListWrapper = styled.div`
  background: '#ebebeb';
  padding: ${({ theme }) => `${theme.spacing[10]} ${theme.spacing[0]}`};

  ${({ theme }) =>
    getProjectName() === 'avito' &&
    `
      background: '#ffffff';
      padding: ${`${theme.spacing[7]} ${theme.spacing[0]} ${theme.spacing[10]}`};
    `}

  .filter-cell {
    ${() =>
      getProjectName() === 'generic_v2' &&
      `
        padding-left: 0;
        padding-right: 0;

        @media (min-width: 768px) {
          margin-top: 80px;
        }
      `}
  }
`
